import { ConnectWalletButton } from '@/components/connect-wallet-button';
import { ReferralBanner } from '@/components/referral-banner';
import { UserProfileCard } from '@/components/user-profile-card';
import { useAuthenticatedLoadingState } from '@/hooks/useAuthenticatedLoadingState';
import { useCurrentUserData } from '@/hooks/useCurrentUserData';
import { AspectRatio, Box, Heading, Image, SimpleGrid, Skeleton, VStack } from '@chakra-ui/react';
import { LottieReact } from '@lottielab/lottie-player';
import { ActionsSection } from './ActionsSection';
import { HomepageRightCard } from './homepage-right-card';

export const HomeHeaderSection = () => {
  const { authenticatedLoadingState } = useAuthenticatedLoadingState();
  const { currentUserData, isLoading: isLoadingCurrentUserData } = useCurrentUserData();
  if (authenticatedLoadingState && isLoadingCurrentUserData) {
    return (
      <VStack gap={4} w="full">
        <SimpleGrid columns={[1, 1, 1, 1, 2]} gap={4} w="full">
          <Skeleton h={[286, 286, 286, 235]} borderRadius="2xl" />
          <Skeleton h={[286, 286, 286, 235]} borderRadius="2xl" />
        </SimpleGrid>
        <SimpleGrid columns={[1, 1, 2, 2, 4]} w="full" gap={4}>
          <Skeleton h="184px" borderRadius="2xl" />
          <Skeleton h="184px" borderRadius="2xl" />
          <Skeleton h="184px" borderRadius="2xl" />
          <Skeleton h="184px" borderRadius="2xl" />
        </SimpleGrid>
      </VStack>
    );
  }

  if (currentUserData) {
    return (
      <VStack gap={4} w="full">
        <SimpleGrid columns={[1, 1, 1, 1, 2]} gap={4} w="full">
          <UserProfileCard />
          <HomepageRightCard />
        </SimpleGrid>
        <ActionsSection />
      </VStack>
    );
  }

  return (
    <VStack gap={4} w="full">
      <ReferralBanner />

      <VStack
        py={8}
        px={6}
        w="full"
        background="radial-gradient(125.86% 243.99% at 50% 21.56%, rgba(211, 211, 211, 0.01) 0%, #93E6FF 99.99%)"
        hideFrom="md"
        gap={4}
        alignItems="center"
        textAlign="center"
        rounded="24px"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
          <path d="M28.3114 15.3894V26.7856L23.8377 22.2748V10.8786L28.3114 15.3894Z" fill="#FF3D00" />
          <path d="M15.8391 27.9717H27.1356L22.6642 23.4585H11.3677L15.8391 27.9717Z" fill="#FF3D00" />
          <path
            d="M34.6697 34.426V21.8039L30.1961 17.293V29.9151L17.7261 29.873L22.1975 34.3861L34.6673 34.4283"
            fill="#FF3D00"
          />
          <path
            d="M5.62451 5.29407L5.62451 17.9161L10.0982 22.427L10.0982 9.80491L22.5682 9.84704L18.0968 5.33388L5.62689 5.29175"
            fill="#FF3D00"
          />
          <path
            d="M35.8525 36.8231L33.3144 34.2626L34.5472 33.0189L37.0853 35.5794L37.3753 37.0426L35.8525 36.8231Z"
            fill="#FF3D00"
          />
        </svg>

        <Heading fontSize="40px" fontWeight="700" lineHeight="48px">
          RWAs That Feel Just Like Crypto
        </Heading>
        <Heading size="xl" color="text.secondary" fontWeight="500">
          Join Plume in bringing the real world to crypto
        </Heading>
        <Box mt={2}>
          <ConnectWalletButton />
        </Box>
      </VStack>
      <Box hideFrom="md" w="full">
        <ActionsSection />
      </Box>
      <Box position="relative" borderRadius="3xl" overflow="hidden" bgColor="bg.subtle" w="100%" hideBelow="md">
        <VStack
          position="absolute"
          left="50%"
          top="50%"
          transform="translate(-50%,-50%)"
          textAlign="center"
          zIndex={1}
          w="100%"
        >
          <Image src="/assets/logo-feather-red.svg" hideBelow="lg" />
          <Heading size="5xl" maxW="449px" fontWeight="700">
            RWAs That Feel Just Like Crypto
          </Heading>
          <Heading size="xl" color="fg.muted" mb={4} fontWeight="500">
            Join Plume in bringing the real world to crypto
          </Heading>
          <ConnectWalletButton />
        </VStack>
        <AspectRatio ratio={1166 / 410}>
          <LottieReact src="https://cdn.lottielab.com/l/9VLP6b8Bfj6JJb.json" />
        </AspectRatio>
      </Box>
    </VStack>
  );
};
